import { createBrowserHistory } from 'history';
import { Map } from 'immutable';
import configureStore from './config-store';

const initialState = Map();

// Create browser history
export const history = createBrowserHistory();

// Configure store
export const store = configureStore(history, initialState);
